// eslint-disable-next-line
import app from './Bootstrapper'

if (process.env.NODE_ENV !== 'production') {
  window.app = app
}
